import React, {FC} from "react";
import {ArrowDownIcon, ArrowsRightLeftIcon, ArrowUpIcon} from '@heroicons/react/20/solid';
import {ReceiveModal} from "./receive";
import {useNavigate} from "react-router-dom";

export type AccountActionsProps = {
    address: string;
}

export const AccountActions: FC<AccountActionsProps> = ({address}) => {
    const navigate = useNavigate();
    const [showReceiveModal, setShowReceiveModal] = React.useState(false);

    return (
        <div className="grid grid-cols-3 gap-4 p-4 text-white">
            <button
                className="flex flex-col items-center justify-center rounded-2xl bg-gradient-to-br from-orange-200 via-orange-300 to-orange-400 hover:brightness-105 hover:scale-105 transition-transform shadow-lg shadow-orange-300/40 p-4"
                onClick={() => setShowReceiveModal(true)}
            >
                <ArrowDownIcon className="h-8 w-8 text-orange-800 drop-shadow" />
                <span className="mt-2 text-sm font-semibold uppercase tracking-wide text-orange-900">
            Receive
        </span>
            </button>

            <button
                className="flex flex-col items-center justify-center rounded-2xl bg-gradient-to-br from-orange-300 via-orange-400 to-orange-500 hover:brightness-105 hover:scale-105 transition-transform shadow-lg shadow-orange-400/30 p-4"
                onClick={() => navigate("/account/send")}
            >
                <ArrowUpIcon className="h-8 w-8 text-orange-900 drop-shadow" />
                <span className="mt-2 text-sm font-semibold uppercase tracking-wide text-orange-950">
            Send
        </span>
            </button>

            <button
                disabled
                className="flex flex-col items-center justify-center rounded-2xl bg-gradient-to-br from-orange-100 via-orange-200 to-orange-300 opacity-40 cursor-not-allowed p-4 shadow-inner"
            >
                <ArrowsRightLeftIcon className="h-8 w-8 text-orange-400" />
                <span className="mt-2 text-sm font-semibold uppercase tracking-wide text-orange-400">
            Swap
        </span>
            </button>

            {showReceiveModal && (
                <ReceiveModal address={address} onClose={() => setShowReceiveModal(false)} />
            )}
        </div>
    );
};